// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"643":"a5741c26","680":"434bc0a1","685":"540c405f","770":"55e1e0bb","872":"c302d939"}[chunkId] + ".chunk.css";
};